import { API } from 'aws-amplify';

export class PersonsService {

   getCurrentPerson = async (personId) => {
      var ReturnObj = {};
      await API.get('IAPI', 'PersonDetails/CurrentPerson/', {
         'queryStringParameters': {
            'personId': personId
         }
      })
         .then((res) => {
            ReturnObj = res;
            return res;
         }).catch((error) => {
            return error;
         }
         );
      return ReturnObj;
   }

   getPersons = async (flightId, personType) => {
      var ReturnObj = [];
      await API.get('IAPI', 'PersonDetails/persons/', {
         'queryStringParameters': {
            'flightId': flightId,
            'personType': personType
         }
      })
         .then((res) => {
            ReturnObj = res;
            return res;
         }).catch((error) => {
            return error;
         }
         );
      return ReturnObj;
   }

   AddPerson = async (values) => {
      var ReturnObj = {};
      var myInit = {
         body: {
            id: null,
            PNR: values.pnr,
            UniqueId: values.uniqueId,
            LastName: values.lastName,
            FirstName: values.firstName,
            TravelDocumentNumber: values.travelDocumentNumber,
            DocTypeMrz: values.docTypeMrz,
            ExpiryDate: values.expiryDate,
            IssuingCountry: values.issuingCountry,
            NationalityCountry: values.nationalityCountry,
            BirthDate: values.birthDate,
            EmbarkingAirport: values.embarkingAirport,
            FinalAirport: values.finalAirport,
            Gender: values.gender,
            PassengerCrew: values.PassengerCrew,
            FlightId: values.FlightId,
            SeatNumber: values.seatNumber,
            PersonalId: values.personalId         }
      }

      await API.post('IAPI', 'PersonDetails/HandleAddPassCrew/', myInit)
         .then((res) => {
            ReturnObj = res;
            return res;
         }).catch((error) => {
            return error;
         }
         );
      return ReturnObj;
   }

   UpdatePerson = async (values) => {
      if (values.passengerCrew === "Passenger") { values.passengerCrew = "FL"; }
      if (values.passengerCrew === "Crew") { values.passengerCrew = "FM"; }
      var ReturnObj = {};
      var myInit = {
         body: {
            id: values.id,
            FlightId: values.flightId,
            PNR: values.pnr,
            UniqueId: values.uniqueId,
            LastName: values.lastName,
            FirstName: values.firstName,
            TravelDocumentNumber: values.travelDocumentNumber,
            DocTypeMrz: values.docTypeMrz,
            ExpiryDate: values.expiryDate,
            IssuingCountry: values.issuingCountry,
            PersonId: values.personId,
            NationalityCountry: values.nationalityCountry,
            BirthDate: values.birthDate,
            EmbarkingAirport: values.embarkingAirport,
            FinalAirport: values.finalAirport,
            Gender: values.gender,
            PassengerCrew: values.passengerCrew,
            SeatNumber: values.seatNumber,
            PersonalId: values.personalId,
            Stage: values.stage,
            Status: values.Status        
      }
      }

      await API.post('IAPI', 'PersonDetails/HandleUpdatePassCrew/', myInit)
         .then((res) => {
            ReturnObj = res;
            return res;
         }).catch((error) => {
            return error;
         }
         );
      return ReturnObj;

   }

   FindPassengerCrew = async (person) => {
      var myInit = {
         body: {
            PNR: person.pnr,
            UniqueId: person.uniqueId,
            FlightId: person.flightId,
            IssuingCountry:person.issuingCountry,
            TravelDocumentNumber:person.travelDocumentNumber
         }
      }
      return await API.post('IAPI', 'PersonDetails/FindPassengerCrew/', myInit)
         .then((res) => {
            return res;
         }).catch((error) => {
            return error;
         }
         );
   };
   deletePerson = async (values) => {
       var ReturnObj = {};
      var myInit = {
         body: {
            id: values.id,
            FlightId: values.flightId,
            PNR: values.pnr,
            UniqueId: values.uniqueId,
            LastName: values.lastName,
            FirstName: values.firstName,
            TravelDocumentNumber: values.travelDocumentNumber,
            DocTypeMrz: values.docTypeMrz,
            ExpiryDate: values.expiryDate,
            IssuingCountry: values.issuingCountry,
            PersonId: values.personId,
            NationalityCountry: values.nationalityCountry,
            BirthDate: values.birthDate,
            EmbarkingAirport: values.embarkingAirport,
            FinalAirport: values.finalAirport,
            Gender: values.gender,
            PassengerCrew: values.passengerCrew,
            SeatNumber: values.seatNumber,
            PersonalId: values.personalId         }
      }

      await API.post('IAPI', 'PersonDetails/delete/', myInit)
         .then((res) => {
            ReturnObj = res;
            return res;
         }).catch((error) => {
            return error;
         }
         );
      return ReturnObj;
   };
}

export default new PersonsService();